import React, { Component } from "react";
import axios from "axios";
import ReactTable from "react-table";
import swal from "sweetalert";
import md5 from "md5";
import sha256 from "crypto-js/sha256";
import HmacSHA256 from "crypto-js/hmac-sha256";
import LoadingSpinner from "../components/Input/LoadingSpinner";
axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Content-Type";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

class ShtoGrumbullime extends Component {
  state = {
    loading:false,
    nrKodi: "",
    posts: [],
    Token: "",
    username: window.UserP.username,
    time: "",
    arsyet: [],
    selected:[],
    enablebutton:false,
    errors: "",
  };

  OnEnterPress = (e) => {
    if(e.keyCode === 13){
        this.handleClick2(e);
        this.setState({
            nrKodi:""
        })
    }
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    
    this.setState({ [name]: value });
  };

  onClearInput = () => {
    this.setState({
      nrKodi: "",
      posts: [],
    });
  };
  handleClick = (e) => {
    this.setState({
        loading:true,
    })
    axios
    .post(window.UserP.url + "POD/ShtoGrumbullime", {
        Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
        username: this.state.username,
        Pode:this.state.posts,
        Perdorues:window.UserP.PerdoruesID,
        Agjensia:parseInt(window.UserP.agency),
    })
    .then((response) => {
      const searchresults = response.data;
      
      for (var i in response.data) {
          this.state.arsyet.push(searchresults[i].ResultMessage);
          this.state.selected.push(searchresults[i].Result);
          
        }
        this.setState({enablebutton:true,loading:false});

    }).catch((error) => {
   
        alert( "Ju lutem kontaktoni departamentin e IT!");
        window.location.reload(false);   
      });
   
  };

  handleClear= (e) => {
    
    this.setState({
        arsyet:[],
        posts:[],
        selected:[],
        enablebutton:false
    })
  };

  handleValidation(param) {
    let errors = {};
    let formIsValid = true;
    if (this.state.nrKodi.length == 0) {
      formIsValid = false;
      errors["name"] = "Ju lutem vendosni podin!";
      document.getElementById("nrKodi").style.borderColor = "red";
    } else if (this.state.nrKodi.length > 1 && this.state.nrKodi.length < 7) {
      formIsValid = false;
      document.getElementById("nrKodi").style.borderColor = "red";
      errors["name"] = "Numri i pod-it nuk eshte i sakte!";
    } else if (this.state.nrKodi.length > 1 && this.state.nrKodi.length < 7) {
      formIsValid = false;
      errors["name"] = "Numri i pod-it nuk eshte i sakte!";
      document.getElementById("nrKodi").style.borderColor = "red";
    } else if (param.includes(this.state.nrKodi)) {
      formIsValid = false;
      errors["name"] = "Numri i pod-it eshte shtuar 1 here!";
      document.getElementById("nrKodi").style.borderColor = "red";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  handleClick2 = (e) => {
    e.preventDefault();   
    var posts = [...this.state.posts];
    
    if (this.handleValidation(posts)) {
        posts.unshift(this.state.nrKodi);
        this.setState({ posts: posts, });
        document.getElementById("nrKodi").style.borderColor = ""; // alert("Form submitted");
        
      } else {
      }

};

  
  render() {
    const columns = [
        {
            Header: "Nr",
            accessor: "",
            id: "row",
            maxWidth: 50,
            filterable: false,
            
            Cell: (row) => {
              return <div>{row.index + 1}</div>;
            },
          },
      {
        Header: "Nr. Podi",
        accessor: "",
        
      },
      {
        Header: "Arsye",
        accessor:"2",
        // getProps: (state, rowInfo, column) => {
        //     return {
                
        //         style: {
        //             background: rowInfo && rowInfo.index%2 == 0 ? '#ff4d4d' : rowInfo && rowInfo.index%2 == 1 ? '#008700':null,
        //             color:rowInfo && rowInfo.index%2 == 0 ?"black":"white",
        //         },
        //     };
        // },
        Cell: arsyet => (
            <span >{this.state.arsyet[arsyet.index]}</span>
          )
      },
      {
        Header: "Hiq nga grida",
        id: "Fshi",
        accessor: (str) => "Fshi",
        maxWidth: 200,
        filterable: false,
       
        Cell: (row) => (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
              
            }}
            onClick={() => {
              let data = this.state.posts;
              data.splice(row.index, 1);
              this.setState({
                posts: data,
              });
            }}
          >
            Delete
          </span>
        ),
      },
    ];
    return (
      <div className="Form">
          
        <div className="card card-body bg-light col-md-6">
        <div className="row">
            <div className="col-md-9">
          <label className="">Nr. POD</label>
          <input
            id="nrKodi"
            name="nrKodi"
            value={this.state.nrKodi}
            className="form-control "
            type="text"
            onChange={(e) => this.handleInputChange(e, "nrKodi")}
            onKeyUp={this.OnEnterPress}
          />
          <span style={{ color: "red" }}>{this.state.errors["name"]}</span>
          </div>
          <div className="col-md-1 mt-3">
          <button className="btn btn-primary mt-2" onClick={this.handleClick2}>
          <span data-notify="icon" className="pe-7s-angle-left-circle" />
          &nbsp; Shto
        </button>
          </div>
          </div>
          
        </div>
      <div className="row">
        <div className="col-md-2">
        <button className="btn btn-primary " onClick={this.handleClick} disabled={this.state.enablebutton}>
          <span data-notify="icon" className="pe-7s-diskette" />
          &nbsp; Ruaj
        </button>
        </div>
        <div className="col-md-3">
        <button className="btn btn-danger " onClick={this.handleClear} disabled={!this.state.enablebutton}>
          <span data-notify="icon" className="pe-7s-trash" />
          &nbsp; Pastro
        </button>
        </div>
        
        </div>
        {this.state.loading? (
                <LoadingSpinner />
              ) : (
        <div className="card card-body bg-light col-md-12 mt-4">
          <ReactTable
            columns={columns}
            data={this.state.posts}
            defaultPageSize={5}
            className="-striped -highlight mt-4"
            pageText="Faqe"
            nextText="Para"
            rowsText="Rreshta"
            previousText="Mbrapa"
            noDataText="Nuk ka te dhena"
            getTrProps={(state, rowInfo) => { 
                if (rowInfo && rowInfo.row && this.state.enablebutton && this.state.selected[rowInfo.index]==false) {
                  
                  return {
                    style: {
                      background:
                        rowInfo.index === this.state.selected ? "" : "#ff4d4d",
                      color: rowInfo.index === this.state.selected ? "" : "black",
                    },
                  };
                }else if(rowInfo && rowInfo.row && this.state.enablebutton && this.state.selected[rowInfo.index]==true){
                    return {
                        style: {
                          background:"#008700",
                          color: "white",
                        },
                      };
                }
                 else {
                  return {};
                }
              }}
          />
        </div>
        )}
      </div>
    );
  }
}

export default ShtoGrumbullime;
